"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APRadioTab = _interopRequireDefault(require("../../common/APRadioTab/APRadioTab"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BuySellTabs = function BuySellTabs(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var baseClass = props.baseClass,
    onClick = props.onClick;
  var classes = (0, _cssClassesHelper.getBEMClasses)(baseClass);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('buy-sell-wrapper')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('buy-sell-radio-tab-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_APRadioTab["default"], {
    customClass: classes(),
    onClick: onClick,
    items: [{
      text: t('Buy'),
      value: _orderEntryFormConstants.buyValue,
      styleName: 'additive',
      dataTest: 'Buy Side'
    }, {
      text: t('Sell'),
      value: _orderEntryFormConstants.sellValue,
      styleName: 'subtractive',
      dataTest: 'Sell Side'
    }],
    name: "side"
  })));
};
BuySellTabs.propTypes = {
  baseClass: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func
};
var _default = exports["default"] = BuySellTabs;